import styled from 'styled-components';
import colors from '@styles/colors';

export default styled.div`
  margin: 10px auto;
  border: 5px solid #ccc;
  border-top: 5px solid ${colors.primary};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
